import { gql } from '@apollo/client';

export const GET_LEGAL_SETUP_CONFIGS = gql`
  query getLegalSetupConfigs {
    liveOps {
      legalSetupConfigs {
        id
        adultAge
        cmpAllowedAge
        attAllowedAge
        updatedAt
      }
      legalSetupRegions {
        id
        countries
      }
      legalSetupBlockModeCountries
    }
  }
`;

export const SET_LEGAL_SETUP_CONFIG = gql`
  mutation setLegalSetupConfig($input: LegalSetupConfigInput!) {
    setLegalSetupConfig(input: $input) {
      id
      adultAge
      cmpAllowedAge
      attAllowedAge
      updatedAt
    }
  }
`;

export const DELETE_LEGAL_SETUP_CONFIG = gql`
  mutation deleteLegalSetupConfig($id: ID!) {
    deleteLegalSetupConfig(id: $id)
  }
`;
